<template>
  <span class="portal-field__label">
    {{ field.label }}
    <span
      v-if="field.required"
      class="portal-field__required-star"
    >*</span>
  </span>
</template>

<script setup lang="ts">
defineProps<{
  field: FieldConfig
}>();
</script>

<style scoped lang="scss">
@import "~/assets/styles/variables";

.portal-field__label {
  color: $form-label-color;
}

.portal-field__required-star {
  color: $form-input-required-star-color;
}
</style>
